// eslint-disable-next-line import/no-named-default
import {
  // eslint-disable-next-line import/no-named-default
  default as SliderOneElement,
  SliderComponent as SliderOneComponent,
} from "@kameleon-section/slider-one-slide-full-width-v1";
import { SliderType as SliderOneType } from "@kameleon-section/slider-one-slide-full-width-v1/types";
import {
  BlockTheme,
  BlockType,
  getDefaultProps,
  KameleonElement,
  PrimaryBlockConfig,
  primaryCollectionBlock,
  SecondaryBlockSize,
  TertiaryBlockSize,
} from "@kameleon-core/lib";
import React from "react";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";

const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Medium,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockTheme: BlockTheme.light,
  blockType: BlockType.PrimaryCollection,
};

export const Slider = primaryCollectionBlock<SliderOneType>(
  blockConfig,
  ({ PrimaryBlocks, ...props }: SliderOneType) => (
    <SliderOneComponent
      PrimaryBlocks={PrimaryBlocks}
      _internalProps={{
        _columns: 2,
        _textElement: "h6",
      }}
      {...props}
    />
  )
);

Slider.defaultProps = getDefaultProps<SliderOneType>(defaults);

export const Element: KameleonElement = {
  ...SliderOneElement,
  component: Slider,
  blockInfo: blockinfo,
};
